import React, { useEffect, useState } from "react";
import { Close, LogoBlack } from "../../../assets/svg";
import CustomTable from "../../../components/customTable/CustomTable";
import {
  DefaultButton,
  DefaultPrimaryButton,
} from "../../../components/micro/input";
import {
  createDocument,
  getAllReportList,
  getServiceReportById,
  getServiceReportList,
  sendAllReportList,
} from "../../../redux/service/slice";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import RippleLoader from "../../../components/loader/RippleLoader";
import { toast } from "react-toastify";
import ButtonLoader from "../../../components/loader/ButtonLoader";

const ViewServiceReport = ({
  onClose,
  selectedSaleId,
  setIsLoading,
  isLoading,
  showSend,
  iscompany,
  setSelectedAction,
  setServiceCount,
  setSelectedRows,
  schedule,
}) => {
  const dispatch = useDispatch();
  const [serviceData, setServiceData] = useState([]);
  const [documentData, setDocumentData] = useState([]);
  const [isModal, setIsModal] = useState(false);
  const [progress, setProgress] = useState(0);

  const { loading } = useSelector((store) => ({
    loading: store?.serviceData?.loading,
  }));

  useEffect(() => {
    const fetchSalesData = async () => {
      let serviceReports = [];
      setProgress(0);

      if (showSend === "bulk") {
        const response = await dispatch(
          getAllReportList({ ids: selectedSaleId })
        );

        const totalItems = response?.payload?.data?.length || 0;

        for (let i = 0; i < totalItems; i++) {
          serviceReports.push(response?.payload?.data[i]);

          const percent = Math.round(((i + 1) / totalItems) * 100);
          setProgress(percent);

          await new Promise((resolve) => setTimeout(resolve, 100));
        }
        if (serviceReports?.length > 0) {
          const documentIds = serviceReports
            .map((report) => report.documents?.id)
            .filter((id) => id !== undefined);

          setDocumentData(documentIds);
        }
        setServiceData(serviceReports);
      } else {
        const results = await Promise.all(
          selectedSaleId.map((id) => dispatch(getServiceReportById({ id })))
        );
        serviceReports = results.map((res) => res.payload?.data);
        setServiceData(serviceReports);
      }
    };

    if (selectedSaleId?.length > 0) {
      fetchSalesData();
    }
  }, [selectedSaleId]);

  const handleDownloadPDF = async () => {
    if (showSend === "bulk") {
      const response = await dispatch(
        createDocument({ ids: documentData })
      ).unwrap();

      const zipUrl = response?.zip;
      if (zipUrl) {
        const a = document.createElement("a");
        a.href = zipUrl;
        a.download = "report_documents.zip";
        document.body.appendChild(a);
        a.click();
        a.remove();
        onClose();
        dispatch(
          getServiceReportList({
            search: "",
            pageCount: 1,
            pageLimit: 10,
            sort_by: "",
            sort_direction: "",
            technician: "",
            status: "",
          })
        );
        setSelectedAction("");
        setServiceCount("");
        setSelectedRows([]);
      } else {
        toast.error("ZIP URL not found in response.");
      }
    } else {
      try {
        const pdf = new jsPDF("p", "mm", "a4");
        const pdfWidth = pdf.internal.pageSize.getWidth();

        for (let i = 0; i < serviceData.length; i++) {
          const pageContent = document.getElementById(`salePage-${i}`);

          const canvas = await html2canvas(pageContent, { scale: 2 });
          const imgData = canvas.toDataURL("image/png");
          const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

          if (i > 0) {
            pdf.addPage();
          }
          pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);

          if (i === serviceData.length - 1) {
            pdf.save("service_preview.pdf");
            toast.success("Your file has been downloaded successfully!");
          }
        }
      } catch (error) {
        toast.error("PDF Download Error:", error);
      }
    }
  };

  const ColumnHeaders = () => (
    <>
      <th
        scope="col"
        className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start w-1/6"
      >
        No.
      </th>
      <th
        scope="col"
        className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start w-5/6 "
      >
        Problem
      </th>
    </>
  );

  const DataRows = ({ data }) => (
    <>
      {data?.service_report_equipments?.map((element, index) => (
        <tr
          key={element.id}
          className="font-Proxima text-[14px] shadow-sm text-mgrey"
        >
          <td className="px-5 py-3">{index + 1}</td>
          <td className="px-5 py-3">{element?.problem_description}</td>
        </tr>
      ))}
    </>
  );

  const SolutionColumnHeaders = () => (
    <>
      <th
        scope="col"
        className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start w-1/6"
      >
        No.
      </th>
      <th
        scope="col"
        className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start w-5/6"
      >
        Solution
      </th>
    </>
  );

  const SolutionDataRows = ({ data }) => (
    <>
      {data?.service_report_equipments?.map((element, index) => (
        <tr className="font-Proxima text-[14px] shadow-sm  text-mgrey ">
          <td className="px-5 py-3">{index + 1}</td>
          <td className="px-5 py-3">{element?.solution_description}</td>
        </tr>
      ))}
    </>
  );

  const handleSendReport = () => {
    setIsLoading(true);

    const payload = {
      ids: selectedSaleId,
    };

    dispatch(sendAllReportList(payload)).then((res) => {
      setIsLoading(false);

      if (res.type === "sendAllReportList/fulfilled") {
        onClose();
        dispatch(
          getServiceReportList({
            search: "",
            pageCount: 1,
            pageLimit: 10,
            sort_by: "",
            sort_direction: "",
            technician: "",
            status: "",
          })
        );
        setSelectedAction("");
        setServiceCount("");
        setSelectedRows([]);
      }
    });
  };

  return (
    <>
      <div className="model" onClick={onClose}>
        <div
          className="bg-white rounded-lg max-w-5xl py-8 px-6 mx-auto relative h-2/3 overflow-auto"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="cursor-pointer flex justify-end">
            <button onClick={onClose}>
              <Close />
            </button>
          </div>
          <div>
            {loading ? (
              <div className="w-full max-w-72">
                <RippleLoader />
              </div>
            ) : (
              <>
                {serviceData?.map((data, index) => (
                  <div key={index} id={`salePage-${index}`}>
                    <div className="w-full shadow-lg rounded-lg py-8 px-6">
                      <div className="flex justify-between">
                        <LogoBlack />
                        <div className="w-1/3">
                          <div>
                            <p className="font-Montserrat font-medium text-xl text-mgrey">
                              FBK Group Pte Ltd
                            </p>
                            <p className="font-Proxima font-normal text-sm text-mgrey">
                              (UEN: 201402444D)
                            </p>
                          </div>
                        </div>
                      </div>
                      {/* report */}
                      <div>
                        <h2 className="text-[34px] font-Montserrat text-mgrey font-normal my-4">
                          Service Report
                        </h2>
                        <p className="mb-2 font-Proxima text-base font-normal text-mgrey">
                          Report ID: {data?.unique_id}
                        </p>
                        <h6 className="text-xl font-Montserrat font-medium mb-4">
                          "{data?.company?.name}"
                        </h6>
                        <div className="flex gap-3 mb-4 border-b border-b-secondaryGrey ">
                          <div className="mb-4 text-sm font-normal font-Proxima text-mgrey">
                            <p>"{data?.outlet_name}"</p>
                            <p className="break-words w-36">
                              {data?.company?.address}
                            </p>
                            <p className="break-words w-36">
                              {data?.company?.postal_code}
                            </p>
                          </div>
                          <div className="text-sm font-normal font-Proxima text-mgrey">
                            <div className="flex">
                              <p className="w-20">Tel:</p>
                              <p> {data?.company?.phone}</p>
                            </div>
                            <div className="flex">
                              <p className="w-20">Email:</p>
                              <p>{data?.company?.email}</p>
                            </div>
                            <div className="flex">
                              <p className="w-20">Date:</p>
                              <p> {moment(data?.date).format("DD/MM/YYYY")}</p>
                            </div>
                          </div>
                        </div>
                        {/* service Type */}
                        <div>
                          <div className="flex flex-col gap-3">
                            <div>
                              <p className="text-sm font-normal text-themeBtn font-Proxima">
                                Type of Service:
                              </p>
                              <p className="text-base font-normal font-Proxima text-mgrey">
                                {data?.type_of_service}
                              </p>
                            </div>
                            <div className="flex items-center gap-5">
                              <div>
                                <p className="text-sm font-normal text-themeBtn font-Proxima">
                                  Date:
                                </p>
                                <p className="text-base font-normal font-Proxima text-mgrey">
                                  {moment(
                                    data?.date || data?.service?.date
                                  ).format("DD/MM/YYYY")}
                                </p>
                              </div>
                              <div>
                                <p className="text-sm font-normal text-themeBtn font-Proxima">
                                  Time Start:
                                </p>
                                <p className="text-base font-normal font-Proxima text-mgrey">
                                  {(data?.start_time ||
                                    data?.service?.start_time) ??
                                    "-"}
                                </p>
                              </div>
                              <div>
                                <p className="text-sm font-normal text-themeBtn font-Proxima">
                                  Time End:
                                </p>
                                <p className="text-base font-normal font-Proxima text-mgrey">
                                  {(data?.end_time ||
                                    data?.service?.end_time) ??
                                    "-"}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* table */}
                      <div>
                        <div className="w-full bg-white shadow rounded-lg mt-5 ">
                          <CustomTable
                            columnHeaders={<ColumnHeaders />}
                            dataRows={<DataRows data={data} />}
                            data={serviceData}
                            isLoading={isLoading}
                          />
                        </div>
                        <div className="w-full bg-white shadow rounded-lg mt-5 ">
                          <CustomTable
                            columnHeaders={<SolutionColumnHeaders />}
                            dataRows={<SolutionDataRows data={data} />}
                            data={serviceData}
                            isLoading={isLoading}
                          />
                        </div>
                      </div>
                      {/* Sign */}
                      <div className="flex justify-between items-center mb-8 mt-28">
                        <div className="font-Proxima font-normal text-sm text-mgrey">
                          <div className="border-b border-b-Grey w-36">
                            <p>Yours Faithfully,</p>
                            <p className="mb-4">FBK Group Pte Ltd</p>
                            <img
                              src={data?.technician_signature}
                              alt="Technician Signature"
                              className="w-36 h-auto"
                            />
                          </div>
                          <p>"{data?.technician_name}"</p>
                        </div>
                        <div className="font-Proxima font-normal text-sm text-mgrey">
                          <div className="border-b border-b-Grey w-36">
                            <p>Acknowledge by</p>
                            <p className="mb-4">"{data?.outlet_name}"</p>

                            {data?.status === "acknowledged" && (
                              <img
                                src={data?.customer_signature}
                                alt="Technician Signature"
                                className="w-36 h-auto"
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
                {/* submit */}
                {schedule ? (
                  " "
                ) : (
                  <div className="flex justify-end gap-2 mt-3">
                    <DefaultPrimaryButton
                      value="download"
                      onClick={handleDownloadPDF}
                    />
                    {iscompany !== "iscompany" && (
                      <DefaultButton
                        value={isLoading ? <ButtonLoader /> : "Send Email"}
                        onClick={() => {
                          showSend === "bulk"
                            ? handleSendReport()
                            : setIsModal(true);
                        }}
                      />
                    )}
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
      {/* {isModal && (
        <SendMailModal
          onClose={handleCloseModal}
          selectedSaleId={selectedSaleId}
          serviceData={serviceData}
          setIsLoading={setIsLoading}
          isLoading={isLoading}
        />
      )} */}
    </>
  );
};

export default ViewServiceReport;
